var render = function render(){var _vm=this,_c=_vm._self._c;return _c('quillEditor',_vm._g(_vm._b({staticClass:"ql-custom-editor",class:{
    'ql-custom-editor__light': _vm.light,
    'ql-custom-editor__active': _vm.isActive,
  },on:{"focus":function($event){_vm.isActive = true},"blur":function($event){_vm.isActive = false}}},'quillEditor',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }